const permissionsFormated = {
    soporte: "soporte",
    dashboard: "Ver el Dashboard de uso de la licencia",
    operaciones: "Ver Operaciones por usuario",
    detalle_operaciones: "Ver el detalle de operaciones por usuario",
    promedio_metricas: "Ver el promedio de metricas en este mes",
    consumo_creditos: "Ver el consumo de creditos",
    uso_estimulos_mes: "Ver el uso de estimulos por mes",
    anterior_uso_estimulos: "Ver anos anterios en el uso de estimulos",
    estimulos_extras: "Ver los estimulos extras",
    crear_carpeta: "Crear carpeta",
    image_analyzer: "Ver apartado imageAnalyzer",
    analizar_imagenes: "Analizar imagenes",
    analizar_videos: "Analizer videos",
    visualizar_mapas: "Visualizar mapas (separar)",
    seleccionar_metricas: "Seleccionar metricas",
    usar_analiticas: "Usar analiticas (separar)",
    barra_lateral_derecha: "Ver barra lateral derecha (separar)",
    detalle_estimulo: "Ver detalle de estimulo",
    comparar_estimulo: "Comparar estimulo",
    descargar_reporte: "Decargar reporte (separar)",
    opciones_estimulos: "Opciones de estimulos (separar)",
    solicitar_estimulos_extras: "Solicitar estimulos extras",
    ver_pago: "Ver apartado de pago (separar)",
    cambiar_lenguaje: "Cambiar lenguaje",
    solicitar_soporte: "Solicitar soporte",
    activar_tours: "Activar Tours",
    agregar_usuarios: "Agregar usuarios",
    ver_perfil: "Ver perfil",
    actualizar_plan: "Actualizar plan (Downgrade/Upgrade)",
    renovar_plan: "Renovar plan",
    cambiar_datos_usuario: "Cambiar datos de usuario",
    cambiar_contrasena: "Cambiar contrasena",
    solicitar_creditos_extras: "Solicitar creditos extras",
    actualizar_roles: "Actualizar Roles",
    actualizar_permisos: "Actualizar permisos",
    ver_permisos: "Ver permisos",
    ver_apartado_usuarios: "Ver apartado usuarios",
    ver_cuentas: "Ver cuentas",
    editar_usuarios: "Editar usuarios",
    eliminar_usuarios: "Eliminar usuarios",
    solicitar_usuarios_extra: "Solicitar usuarios extra",
    ver_recomendaciones_generativas: "Ver recomendaciones generativas"
  }
  

export default permissionsFormated